import type { Nullable } from "@msuite/utils/types";
import type { LucideIcon } from "lucide-react";
import * as Icons from "lucide-react";

export type IconName = Exclude<keyof typeof Icons, `${string}Icon` | "icons">;

interface IconProps extends Omit<Icons.LucideProps, "size"> {
	name: IconName;
	size?: Nullable<number>;
}

function Icon({ name, size, style, ...props }: IconProps) {
	/** TODO: Fix this issue to reduce bundle size */
	/** biome-ignore lint: lint/performance/noDynamicNamespaceImportAccess */
	const LucideIcon = Icons[name] as LucideIcon;
	const resolvedSize = size || 12;

	return (
		<LucideIcon
			size={resolvedSize}
			strokeWidth={2}
			style={{
				width: `calc(${resolvedSize}px * var(--font-scale, 1))`,
				height: `calc(${resolvedSize}px * var(--font-scale, 1))`,
				...style,
			}}
			{...props}
		/>
	);
}

export function icon(name: IconName) {
	return (props: Omit<IconProps, "name">) => (
		<Icon
			name={name}
			{...props}
		/>
	);
}

export type IconType = ReturnType<typeof icon>;

export { Icon };
